import {gql} from "@apollo/client";

export const FormResponseFragment = gql`
	fragment FormResponseFragment on Form {
		error
		success
	}
`

export const ContactForm = gql`
	${FormResponseFragment}
	mutation ($name: String!, $phone: String, $recaptcha: String!, $email: String!, $subject: String!, $message: String!, ) {
		ContactForm (name: $name, phone: $phone, recaptcha: $recaptcha, email: $email, subject: $subject, message: $message, ) {
			...FormResponseFragment
		}
	}
`

